import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import TitleTextBox from '@/component/TitleTextBox';
import Pagenation from '@/component/Pagenation';
import SearchBtn from '@/component/SearchBtn';

interface ModalType2Props {
  children: ReactNode;
}

const ModalType2 = ({ children }: ModalType2Props) => {
  return (
    <>
      <CS.ModalBg>
        <CS.ModalType2>{children}</CS.ModalType2>
      </CS.ModalBg>
    </>
  );
};

export default ModalType2;
